/**
 * Created by strunz on 05.05.2017.
 */

import {Component, Input} from '@angular/core';
import {Option} from '../../classes/option';


@Component({
    selector: 'groupList',
    templateUrl: './groupList.component.html',
    styleUrls: ['./groupList.component.css']
})
export class GroupListComponent {
    @Input() option: Option;

}
